<div class="location-route-data" *ngIf="!skeletonLoading">

    <!-- zona principal (titulo y estado) -->
    <div class="data-container">
        <div class="data-row" *ngIf="routeSheetLocation.identifierChild != null && routeSheetLocation.identifierChild != ''">
            <div class="">
                <label class="title bold"> Id:</label>
            </div>
            <div class="">
                <label class="body"> {{ routeSheetLocation.identifierChild | slice:0:30}}</label>
            </div>
        </div>

        <div *ngIf="routeSheetLocation.status != null && routeSheetLocation.status != ''" class="data-row orange">
            <div class="">
                <label class="title light-bold"> Estatus:</label>
            </div>
            <div class="">
                <label class="body bold"> {{ routeSheetLocation.status | slice:0:30}}</label>
            </div>
        </div>
        
    </div>

    <!-- zona de fechas -->
    <!-- <div class="row data-container">

        <div class="">
            <label class="title light-bold"> Fecha:</label>
        </div>

        <div class="data-row">
            <div class="">
                <label class="title"> Atención:</label>
            </div>
            <div class="">
                <label class="body light-bold"> {{ routeSheetLocation.attentionTime | date:'dd | MM | yy' }} |
                    <span class="bold">{{ routeSheetLocation.attentionTime | date:'hh:mm a' }}</span>
                </label>
            </div>
        </div>

        <div class="data-row">
            <div class="">
                <label class="title"> Vencimiento:</label>
            </div>
            <div class="">
                <label class="body light-bold"> {{ routeSheetLocation.warrantyTime | date:'dd | MM | yy' }} |
                    <span class="bold">{{ routeSheetLocation.warrantyTime | date:'hh:mm a' }}</span>
                </label>
            </div>
        </div>
        
    </div> -->

    <!-- zona de importantes -->
     <div class="data-container" *ngIf="routeSheetLocation.customer != null && routeSheetLocation.customer != ''">

        <div class="data-row">
            <div class="">
                <label class="title bold"> Cliente:</label>
            </div>
            <div class="">
                <label class="body light-bold"> {{ routeSheetLocation.customer | slice:0:30}}</label>
            </div>
        </div>
        
    </div>

    <!-- zona de datos generales -->
    <div class="data-container">

        <div class="data-row" *ngIf="routeSheetLocation.title != null && routeSheetLocation.title != ''">
            <div class="">
                <label class="title bold"> Nombre:</label>
            </div>
            <div class="">
                <label class="body light-bold"> {{ routeSheetLocation.title | slice:0:30}}</label>
            </div>
        </div>

        <div class="data-row" *ngIf="routeSheetLocation.description != null && routeSheetLocation.description != ''">
            <div class="">
                <label class="title bold"> Descripción:</label>
            </div>
            <div class="">
                <label class="body light-bold"> {{ routeSheetLocation.description | slice:0:30}}</label>
            </div>
        </div>
        
    </div>

</div>


<!-- -------------LOADER--------------- -->
<div class="location-route-data" *ngIf="skeletonLoading">
    <div class="data-container">
        <div class="data-row">
            <div class="">
                <label class="title bold"> 
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '40px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
            <div class="">
                <label class="body">
                  <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '150px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
        </div>

        <div class="data-row orange">
            <div class="">
                <label class="title light-bold"> 
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '40px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
            <div class="">
                <label class="body bold">
                  <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '150px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
        </div>
    </div>

    <div class="data-container">
        <div class="data-row-vertical">
            <div class="">
                <label class="title bold"> 
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '40px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
            <div class="">
                <label class="body light-bold">
                  <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '150px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
        </div>
    </div>

    <div class="data-container">
        <div class="data-row">
            <div class="">
                <label class="title bold"> 
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '40px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
            <div class="">
                <label class="body light-bold">
                  <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '150px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
        </div>

        <div class="data-row">
            <div class="">
                <label class="title bold"> 
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '40px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
            <div class="">
                <label class="body light-bold">
                  <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '150px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
        </div>

        <div class="data-row">
            <div class="">
                <label class="title bold"> 
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '40px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
            <div class="">
                <label class="body light-bold">
                  <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '150px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
        </div>

        <div class="data-row">
            <div class="">
                <label class="title bold"> 
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '40px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
            <div class="">
                <label class="body light-bold">
                  <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '150px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
        </div>
    </div>
</div>
  